"use client";

import React from "react";
import "./ChooseUsSection.scss";
import Image from "next/image";

const ChooseUsSection = ({ chooseUs }) => {
  if (!chooseUs) return null;

  const { title, description, items = [] } = chooseUs;

  return (
    <section className="choose-us-section">
      <div className="container">
        <div className="choose-us-top">
          <h2>{title}</h2>

          <p>{description}</p>
        </div>

        <div className="choose-us-grid">
          {items.map((item, index) => (
            <div className="choose-us-card" key={index}>
              <div className="icon-box">
                <Image
                  src={item.icon}
                  alt={item.title}
                  width={90}
                  height={90}
                />
              </div>

              <h4>{item.title}</h4>

              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChooseUsSection;